import { AgendaItem, SummaryBlock, SummaryBlockExtData, SummaryBlockItem } from "@api";
import { cloneDeep } from 'lodash';
export class SummaryMeta {
    Version: string;
    Author: string;
    
    constructor() {
        this.Version = "3.0";
    }
}

export const makeDefaultSummaryBlocks = (data: SummaryBlock[]): SummaryBlock[] => {
    if (!data) {
        data = SummeetConfig.defaultSummaryBlockNames.map(blockName => new SummaryBlock({
            blockName: blockName,
            items: [],
            showAgenda: SummeetConfig.defaultSummaryBlocksWithAgenda && SummeetConfig.defaultSummaryBlocksWithAgenda.includes(blockName),
        }))
    }

    SummeetConfig.defaultSummaryBlockNames.forEach((blockName, index) => {
        const blockIndex = data.findIndex(block => block.blockName == blockName);

        if (blockIndex == -1) {
            data.splice(index, 0, new SummaryBlock({
                blockName: blockName,
                items: [],
                showAgenda: SummeetConfig.defaultSummaryBlocksWithAgenda && SummeetConfig.defaultSummaryBlocksWithAgenda.includes(blockName),
            }));
        } else {
            const block = data[blockIndex];
            data.splice(blockIndex, 1)
            data.splice(index, 0, block);
        }

    });

    return data;
}

export const getBlockItems = (data: SummaryBlockExtData, agendaItemId: string): SummaryBlockItem[] => {
    return (agendaItemId ? data.agendaItems[agendaItemId] : data.items) || [];
}

export const setBlockItems = (data: SummaryBlockExtData, agendaItemId: string, items: SummaryBlockItem[]): void => {
    if (agendaItemId) {
        data.agendaItems[agendaItemId] = items;
    } else {
        data.items = items;
    }
}

export class SummaryBlockItemWitCoord {
    blockIndex: number;
    itemIndex: number;
    summaryAgendaItemId: string;
    item: SummaryBlockItem;
}

export const deleteSummaryItem = (
	summaryItemIndex: number,
	summaryBlockIndex: number,
	summaryAgendaItemId: string,
	summaryBlocks: SummaryBlock[],
): SummaryBlock[] => {

	const updatedBlock: SummaryBlock = cloneDeep(summaryBlocks[summaryBlockIndex]);
	let items = getBlockItems(updatedBlock.__data, summaryAgendaItemId);
	items = items.filter((item, index) => index != summaryItemIndex)
	setBlockItems(updatedBlock.__data, summaryAgendaItemId, items);
	updatedBlock.items = updatedBlock.__data.getAllItems();
	summaryBlocks[summaryBlockIndex] = updatedBlock;

	return summaryBlocks;
}

export const extractTasks = (summaryBlocks: SummaryBlock[], hideSendTasks: boolean): SummaryBlockItemWitCoord[] => {
	if (!summaryBlocks) {
		return [];
	}
	
	const tasks: SummaryBlockItemWitCoord[] = [];
	for (let block_ix = 0; block_ix < summaryBlocks.length; block_ix++) {
		const block = summaryBlocks[block_ix];
		for (let item_ix = 0; item_ix < block.items.length; item_ix++) {
			const item = block.items[item_ix];
			if ((item.selectedPersons && item.selectedPersons.length) || item.selectedDate) {
				if (hideSendTasks && item.taskLink) {
					continue;
				}
				const task = new SummaryBlockItemWitCoord();
				task.blockIndex = block_ix;
				task.itemIndex = item_ix;
				task.summaryAgendaItemId = item.agendaItemId;
				task.item = item;
				tasks.push(task);
			}
		}
	}

	return tasks;
}

export interface IDragData {
    source: 'transcript' | 'summary' | 'agenda';
    text?: string;
    summaryItemIndex?: number,
    summaryItem?: SummaryBlockItem,
    summaryBlock?: SummaryBlock,
    agendaItemIndex?: number,
    agendaItem?: AgendaItem,
}


export const SessionSummaryDragDataKey = 'drag_data';